import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { useTranslation } from "react-i18next";

const COLORS = {
  D: "#FD8100",
  I: "#F59E0B",
  S: "#16A34A",
  C: "#0EA5E9",
};

const LABELS_FR = { D: "Dominant", I: "Influent", S: "Stable", C: "Conforme" };
const LABELS_EN = { D: "Dominant", I: "Influent", S: "Steady", C: "Compliant" };

export default function BPMChart({ distribution, testId = "bpm-chart" }) {
  const { i18n } = useTranslation();
  const LABELS = (i18n.language || "fr").startsWith("en") ? LABELS_EN : LABELS_FR;
  const data = Object.entries(distribution || {}).map(([k, v]) => ({ name: k, fullName: LABELS[k], value: v }));
  const total = data.reduce((a, b) => a + b.value, 0);

  return (
    <div className="w-full" data-testid={testId}>
      <div className="h-48 md:h-56">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={75}
              innerRadius={45}
              paddingAngle={2}
              label={({ name, value }) => total > 0 ? `${name} ${Math.round(value)}%` : ""}
              labelLine={false}
            >
              {data.map((entry) => (
                <Cell key={entry.name} fill={COLORS[entry.name]} stroke="#FFFFFF" strokeWidth={2} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value, name) => [`${value}%`, LABELS[name] || name]}
              contentStyle={{ background: "#fff", border: "1px solid #E4E4E4", borderRadius: 8, fontSize: 12 }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="grid grid-cols-4 gap-2 mt-2">
        {data.map((d) => (
          <div key={d.name} className="text-center">
            <div className="text-xs text-text-secondary">{LABELS[d.name]}</div>
            <div className="font-mono font-bold text-sm" style={{ color: COLORS[d.name] }}>{d.value}%</div>
          </div>
        ))}
      </div>
    </div>
  );
}
